<template>
  <div>
    <div class="opo02">
      <span class="opo03">商品列表</span>
    </div>
    <div class="opo01">
      <div class="djt30">
        <div class="djt31">
          <input v-model="searchs" type="text" placeholder="输入商品名称进行搜索" placeholder-class="djt32" class="djt33">
          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">
        </div>
      </div>
      <div style="width: 100%;display: flex;justify-content: flex-end">
        <div v-if="user.companytype == 1" class="djt02s" style="margin-right: 20px">
         <img src="@/assets/imgs/08.png" class="djt03" alt="">
         <a class="djt04" href="https://inter.jmi-cloud.com/app/img/0da921f0-85a1-40f1-bb02-cb15f1c7caa3.xls">导入模板</a>
       </div>
        <div v-if="user.companytype == 1" class="djt02s" @click="importd" style="margin-right: 20px">
         <img src="@/assets/imgs/08.png" class="djt03" alt="">
         <p class="djt04">导入刀具bom表</p>
       </div>
       <div v-if="user.companytype == 1" class="djt02s" @click="exportd" style="margin-right: 20px">
         <img src="@/assets/imgs/08.png" class="djt03" alt="">
         <p class="djt04">导出刀具bom表</p>
       </div>
        <div class="djt02" @click="spsh">
          <img src="@/assets/images/qw6.png" class="djt03" alt="">
          <p class="djt04">添加商品</p>
        </div>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26g">图片</div>
        <div class="djt26g">名称</div>
        <div class="djt26g">编码</div>
        <!-- <div class="djt26g">加工产品编码</div> -->
        <div class="djt26g">单位</div>
        <!-- <div class="djt26g">组织架构</div> -->
        <div class="djt26g" v-if="user.companytype == 1">型号</div>
        <div class="djt26g" v-else>规格</div>
        <div class="djt26g">价格</div>
        <div class="djt26g">分类</div>
        <div class="djt26g">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27g2" style="display: flex;justify-content: center;">
              <img :src="item.url" alt="" class="bpk01">
            </div>
            <div class="djt27g2" :title="item.name">{{item.name}}</div>
            <div class="djt27g2" :title="item.code">{{item.code}}</div>
            <!-- <div class="djt27g2" :title="item.productcode">{{item.productcode}}</div> -->
            <div class="djt27g2" :title="item.unit">{{item.unit}}</div>
            <!-- <div class="djt27g2" :title="item.orgidname2">{{item.orgname2}}</div> -->
            <div class="djt27g2" v-if="user.companytype == 1" :title="item.model">{{item.model}}</div>
            <div class="djt27g2" v-else :title="item.specs">{{item.specs}}</div>
            <div class="djt27g2" :title="item.price">{{item.price}}</div>
            <div class="djt27g2">
              <div class="djs01" :title="item.sortname" style="margin-right: 10px">{{item.sortname}}</div>
              <div class="djs01" :title="item.sortname2">{{item.sortname2}}</div>
            </div>
            <div class="djt28g2">
              <img src="@/assets/images/qw7.png" v-if="item.isup == 2" @click="sxj(item)" title="下架" class="djy16s" alt="" >
              <img src="@/assets/images/qw8.png" v-else title="上架" @click="sxj(item)" class="djy16s" alt="" >
              <img src="@/assets/images/ed01.png" title="修改信息" @click="toXg(item)" class="djy16s" alt="" style="margin-left: 20px">
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
    <xc-model :loading="xgModel" title="修改信息" :is_buttom="false" @cancel="xgcancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">名称：</div>
            <input v-model="xgname" type="text" placeholder="请输入名称" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">单位：</div>
            <input v-model="xgunit" type="text" placeholder="请输入单位" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">编码：</div>
            <input v-model="xgnum" type="text" placeholder="请输入编码" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">规格：</div>
            <input v-model="xgspec" type="text" placeholder="请输入规格" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">型号：</div>
            <input v-model="xgguig" type="text" placeholder="请输入型号" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">价格：</div>
            <input v-model="xgjiag" type="text" placeholder="请输入价格" class="djt20">
          </div>
          <!-- 组织架构 -->
          <div class="djt18" style="margin-top: 20px;">
            <div class="djt19">组织架构：</div>
            <div class="bpk02g2">
              <el-select v-model="xgzuzhi" class="djs02" filterable placeholder="请选择" @change="zuzhixz">
                <el-option
                  label="请选择"
                  value="请选择">
                </el-option>
                <el-option
                  v-for="(item,index) in companyList"
                  :key="'zuz'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select class="djs03" v-model="xgerzuzhi" filterable placeholder="请选择" @change="erjizuzhixz">
                <el-option
                  v-for="(item,index) in erjiCompanyList"
                  :key="'ej'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">分类：</div>
            <div class="bpk02">
              <el-select v-model="xgyiji" class="djs02" filterable placeholder="请选择" @change="yjxz">
                <el-option
                  label="请选择"
                  value="请选择">
                </el-option>
                <el-option
                  v-for="(item,index) in yjArr.dataList"
                  :key="'yj'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select class="djs03" v-model="xgerji" filterable placeholder="请选择">
                <el-option
                  v-for="(item,index) in erArr.dataList"
                  :key="'ej'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">图片：</div>
            <div class="bpk02g2" style="position: relative">
              <img :src="imageUrl" style="width: 200px;height: 200px;cursor: pointer" alt="">
              <Upload
                class="bpk04o4"
                :on-success="succGz"
                :multiple="false"
                type="drag"
                action="/load/gyy/api/uploadfile">
                <div>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽以上传图片</p>
                </div>
              </Upload>
            </div>
          </div>
          <p class="djg46">ERP参数</p>
          <div class="djt45"></div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp货号编码：</div>
            <input v-model="xgerpcode" type="text" placeholder="请输入erp货号编码" class="djt20">
          </div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp基础单位编码：</div>
            <input v-model="xgerpbaseunit" type="text" placeholder="请输入erp基础单位编码" class="djt20">
          </div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp单位编码：</div>
            <input v-model="xgerpunit" type="text" placeholder="请输入erp单位编码" class="djt20">
          </div>
          <div class="djt21">
            <div class="djt22" @click="xgshre">修改</div>
            <div class="djt22" style="margin-left: 50px" @click="xgcancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <xc-model :loading="isModel" title="添加商品" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">名称：</div>
            <input v-model="name" type="text" placeholder="请输入名称" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">单位：</div>
            <input v-model="units" type="text" placeholder="请输入单位" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">编码：</div>
            <input v-model="num" type="text" placeholder="请输入编码" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">规格：</div>
            <input v-model="spec" type="text" placeholder="请输入规格" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">型号：</div>
            <input v-model="guig" type="text" placeholder="请输入型号" class="djt20">
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">价格：</div>
            <input v-model="jiage" type="text" placeholder="请输入价格" class="djt20">
          </div>
          <!-- 组织架构 -->
          <div class="djt18" style="margin-top: 20px;">
            <div class="djt19">组织架构：</div>
            <div class="bpk02g2">
              <el-select v-model="zuzhi" class="djs02" filterable placeholder="请选择" @change="zuzhixz">
                <el-option
                  label="请选择"
                  value="请选择">
                </el-option>
                <el-option
                  v-for="(item,index) in companyList"
                  :key="'zuz'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select class="djs03" v-model="erzuzhi" filterable placeholder="请选择" @change="erjizuzhixz">
                <el-option
                  v-for="(item,index) in erjiCompanyList"
                  :key="'ej'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">分类：</div>
            <div class="bpk02g2">
              <el-select v-model="yiji" class="djs02" filterable placeholder="请选择" @change="yjxz">
                <el-option
                  label="请选择"
                  value="请选择">
                </el-option>
                <el-option
                  v-for="(item,index) in yjArr.dataList"
                  :key="'yj'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select class="djs03" v-model="erji" filterable placeholder="请选择">
                <el-option
                  v-for="(item,index) in erArr.dataList"
                  :key="'ej'+index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="djt18" style="margin-top: 20px">
            <div class="djt19">图片：</div>
            <div class="bpk02g2 tjbps01" style="position: relative">
              <img src="@/assets/images/qw3.png" class="bpk03" alt="" v-if="imageUrls == ''">
              <img :src="imageUrls" class="bpk03" alt="" v-else>
              <Upload
                class="bpk04o4s"
                :on-success="succGzs"
                :multiple="false"
                type="drag"
                action="/load/gyy/api/uploadfile">
                <div>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽以上传图片</p>
                </div>
              </Upload>
            </div>
          </div>
          <p class="djg46">ERP参数</p>
          <div class="djt45"></div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp货号编码：</div>
            <input v-model="erpcode" type="text" placeholder="请输入erp货号编码" class="djt20">
          </div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp基础单位编码：</div>
            <input v-model="erpbaseunit" type="text" placeholder="请输入erp基础单位编码" class="djt20">
          </div>
          <div class="djg48" style="margin-top: 20px">
            <div class="djg47">erp单位编码：</div>
            <input v-model="erpunit" type="text" placeholder="请输入erp单位编码" class="djt20">
          </div>
          <div class="djt21">
            <div class="djt22" @click="shre">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
    <!-- 导入刀具BOM表弹框 -->
    <xc-model :loading="importModel" title="导入刀具BOM" :is_buttom="false" @cancel="guanbi">
      <div slot="mbody">
        <div class="djt17s">
          <div style="width: 100%;display: flex;justify-content: center">
            <Upload
              ref="uploads"
              class="vers01s"
              :on-success="succGzd"
              limit:="1"
              :multiple="false"
              :data="multipartFile"
              :default-file-list="lists"
              type="drag"
              action="/load/excel/api/uploaddjbom">
              <div>
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或者拖拽以上传版本文件</p>
              </div>
            </Upload>
          </div>
          <!-- <div class="djt21s1">
            <div class="djt22s1" @click="addVers">确认</div>
            <div class="djt22s1" style="margin-left: 50px" @click="guanbi">取消</div>
          </div> -->
        </div>
      </div>
    </xc-model>
    <style>
      .el-input__inner{
        border: none !important;
      }
      .tjbps01 .ivu-upload-drag{
        height: 77px;
      }
      .tjbps01 .ivu-upload-drag p{
        display: none;
      }
    </style>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import https from '@/api/schemaSequence';
  import util from '@/util/util';
  import http from 'axios';
  export default {
    name: "djgbpk",
    data(){
      return{
        multipartFile:{companyid:''},
        importModel:false,
        lists:[],
        user:'',
        dds:'',
        orgid:'',
        companyList:[],
        zuzhi:'',
        erzuzhi:'',
        xgzuzhi:'',
        xgerzuzhi:'',
        erjiCompanyList:[],
        guig:'',
        units:'',
        erpcode:'',
        erpbaseunit:'',
        erpunit:'',
        xgguig:'',
        xgerpcode:'',
        xgerpbaseunit:'',
        xgerpunit:'',
        searchs:'',
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: '',
        jiage:'',
        yiji:'',
        erji:'',
        biaop:'',
        yjArr:[],
        erArr:[],
        bpArr:[],
        lsItem:[],
        xgModel:false,
        xgjiag:'',
        xgyiji:'',
        xgerji:'',
        imgUrl:'',
        imageUrls:'',
        xgname:'',
        xgnum:'',
        xgunit:'',
        xgspec:'',
        urls:''
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      me.user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        page:1,
        pageSize:me.pageSize,
        companyid:user.companyId,
      }
      https.getgoodslistbyorg(data).then(res => {
        me.data = res.data;
        me.loading = false;
      })
      me.multipartFile.companyid = user.companyId
    },
    methods:{
      addVers(){
        let data = {
          companyid:'',
          file:me.urls
        }
        https.uploaddjbom(data).then(res=>{
          console.log(res)
          if(res.code == '0000') {
            me.$message.success("导入成功")
            let data = {
              page:1,
              pageSize:me.pageSize,
              companyid:user.companyId,
            }
            https.getgoodslistbyorg(data).then(res => {
              me.data = res.data;
              me.loading = false;
            })
          }else if(res.code == '2000') {
            me.$message.error("写入文件流失败")
          }else if(res.code == '2001') {
            me.$message.error("文件大于50mb")
          }else if(res.code == '2002') {
            me.$message.error("读取文件流失败")
          }
        })
      },
      guanbi(){
        me.importModel = false
      },
      succGzd(e){
        console.log(e,"liliji")
        me.$refs.uploads.clearFiles();
        if(e.code == '0000'){
          me.$message.success("导入成功")
          me.importModel = false
          let data = {
            page:1,
            pageSize:me.pageSize,
            companyid:user.companyId,
          }
          https.getgoodslistbyorg(data).then(res => {
            me.data = res.data;
            me.loading = false;
          })
        }else if(e.code == '2000') {
          me.$message.error("写入文件流失败")
          me.importModel = false
        }else if(e.code == '2001') {
          me.$message.error("文件大于50mb")
          me.importModel = false
        }else if(e.code == '2002') {
          me.$message.error("读取文件流失败")
          me.importModel = false
        }
      },
      // 导入刀具BOM表
      importd(){
        me.importModel = true
      },
      // 导出刀具BOM表
      exportd(){
        me.$Loading.start();
        let data = {
          companyid:user.companyId
        }
        https.exportdjbom(data).then(res=>{
          const blob = new Blob([res],{ type: 'application/vnd.ms-excel'});//处理文档流
          const fileName = '刀具BOM表.csv';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          me.loading = false;
          me.$Loading.finish();
        })
      },
      toXg(item){//前往修改
        this.$router.push({path:'/productEdit',query:{item:JSON.stringify(item)}})
        // console.log(item,"111");
        // me.xgzuzhi = item.orgname
        // me.xgerzuzhi = item.orgname2
        // me.orgid = item.orgid2
        // me.lsItem = item;
        // me.xgname = item.name;
        // me.xgspec = item.specs;
        // me.xgnum = item.code;
        // me.xgunit = item.unit
        // me.xgjiag = item.price;
        // me.xgyiji = item.sortid;
        // me.xgerji = item.sortid2;
        // me.imageUrl = item.url;
        // me.xgguig = item.model;
        // me.xgerpunit = item.erpunit;
        // me.xgerpcode = item.erpcode;
        // me.xgerpbaseunit = item.erpbaseunit;
        // me.$Loading.start();
        // let data = {
        //   companyid:user.companyId,
        //   pid:0,
        //   page:1,
        //   pageSize:10000,
        // }
        // let data2 = {
        //   companyid:user.companyId,
        //   pid:item.sortid,
        //   page:1,
        //   pageSize:10000,
        // }
        // http.all([httpUser.getgoodssortlist(data),httpUser.getgoodssortlist(data2)]).then(http.spread(function (res1,res2) {
        //   me.yjArr = res1.data;
        //   me.erArr = res2.data;
        //   me.$Loading.finish();
        //   me.xgModel = true;
        // }))
        // let data1 = {
        //   companyId:user.companyId,
        //   pid:0
        // }
        // https.orgListSearch(data1).then(res=>{
        //     let datas = {
        //           companyId:res.data.orglist[0].companyId,
        //           pid:res.data.orglist[0].id
        //       };
        //     https.orgListSearch(datas).then(re=>{
        //         this.companyList = re.data.orglist
        //     })
        //     me.$Loading.finish();
        //     me.xgModel = true;
        // })
        // let data3 = {
        //   companyId:user.companyId,
        //   pid:item.orgid
        // }
        // https.orgListSearch(data3).then(res=>{
        //     me.erjiCompanyList = res.data.orglist
        //     me.$Loading.finish();
        //     me.xgModel = true;
        // })
      },
      xgshre(){//确认修改
        if (me.xgname == '' || util.checkSpace(me.xgname) || util.noBq().test(me.xgname)) {
          me.$message.error('名称不能为空并不能含有空格或者符号');
          return false;
        }
        if (me.xgunit == '' || util.checkSpace(me.xgunit) || util.noBq().test(me.xgunit)) {
          me.$message.error('单位不能为空并不能含有空格或者符号');
          return false;
        }
        if (me.xgnum == '' || util.checkSpace(me.xgnum) || util.noBq().test(me.xgnum)) {
          me.$message.error('编码不能为空并不能含有空格或者符号');
          return false;
        }
        
        if (me.xgspec == '' || util.checkSpace(me.xgspec) || util.noBq().test(me.xgspec)) {
          me.$message.error('规格不能为空并不能含有空格或者符号');
          return false;
        }
        if (me.xgjiag == '' || util.checkSpace(me.xgjiag) || util.noBq().test(me.xgjiag)) {
          me.$message.error('价格不能为空并不能含有空格或者符号');
          return false;
        }
        if (util.checkSpace(me.xgguig) || util.noBq().test(me.xgguig)) {
          me.$message.error('规格不能含有空格或者符号');
          return false;
        }
        if (util.checkSpace(me.xgerpcode) || util.noBq().test(me.xgerpcode)) {
          me.$message.error('erp货号编码不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.xgerpbaseunit) || util.noBq().test(me.xgerpbaseunit)) {
          me.$message.error('erp基础单位不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.xgerpunit) || util.noBq().test(me.xgerpunit)) {
          me.$message.error('erp单位不能含有空格或者表情');
          return false;
        }
        if (me.xgzuzhi == '' || me.xgzuzhi == '请选择' || me.xgzuzhi == null || me.xgerzuzhi == '' || me.xgerzuzhi == '请选择' || me.xgerzuzhi == null) {
          me.$message.error('请选择组织架构');
          return false;
        }
        if (me.xgyiji == '' || me.xgyiji == '请选择' || me.xgerji == '' || me.xgerji == '请选择') {
          me.$message.error('请选择分类');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:me.lsItem.id,
          name:me.xgname,
          code:me.xgnum,
          unit:me.xgunit,
          specs:me.xgspec,
          price:me.xgjiag,
          sortid:me.xgyiji,
          sortid2:me.xgerji,
          url:me.imageUrl,
          orgid:me.orgid,
          isup:2,
          // commid:me.bpArr.dataList[me.biaop].id,
          companyid:user.companyId,
          model:me.xgguig,
          erpcode:me.xgerpcode,
          erpbaseunit:me.xgerpbaseunit,
          erpunit:me.xgerpunit,
        }
        https.addorupdatecupgoodsbyorg(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                page:me.page,
                pageSize:me.pageSize,
                companyid:user.companyId,
              }
              https.getgoodslistbyorg(data).then(res => {
                me.data = res.data;
                me.xgModel = false;
                me.$Loading.finish();
                me.$message.success('已修改商品');
                console.log(res);
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('重复添加');
              break;
          }
        })
      },
      sxj(item){//上下架
        console.log(item);
        me.$Loading.start();
        let data = {
          id:item.id,
          isup:'',
          companyid:user.companyId,
        }
        if (item.isup == 1) {
          data['isup'] = 2;
        } else {
          data['isup'] = 1;
        }
        httpUser.addorupdatecupgoods(data).then(res => {
          switch (res.code) {
            case "0000":
              let datas = {
                page:me.page,
                pageSize:me.pageSize,
                companyid:user.companyId,
              }
              https.getgoodslistbyorg(datas).then(res => {
                me.data = res.data;
                me.$Loading.finish();
                if (data['isup'] == 1) {
                  me.$message.success('已下架');
                } else {
                  me.$message.success('已上架');
                }
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('重复添加');
              break;
          }
        })
      },
      bpxz(e){//标品选中
        me.name = me.bpArr.dataList[e].name;
        me.num = me.bpArr.dataList[e].code;
        me.spec = me.bpArr.dataList[e].specs;
        me.imgUrl = me.bpArr.dataList[e].url;
      },
      yjxz(e){//一级选中
        if (e == '请选择') {
          me.erji = '';
          me.xgerji = '';
          me.erArr = [];
          return false;
        }
        me.erji = '';
        me.xgerji = '';
        me.erArr = [];
        let data = {
          companyid:user.companyId,
          pid:e,
          page:1,
          pageSize:10000,
        }
        httpUser.getgoodssortlist(data).then(res => {
          me.erArr = res.data;
        })
      },
      zuzhixz(e){
        // console.log(e,"李航")
        // 获取组织架构
        let data1 = {
          companyId:user.companyId,
          pid:e
        }
        https.orgListSearch(data1).then(res=>{
            me.erjiCompanyList = res.data.orglist
        })
      },
      erjizuzhixz(e){
        console.log(e,'lilihang')
        this.orgid = e
      },
      spsh(){//标品搜索
        me.$router.push({path:'/productAdd'})
        // me.$Loading.start();
        // let data1 = {
        //   companyId:user.companyId,
        //   pid:0
        // }
        // https.orgListSearch(data1).then(res=>{
        //     let datas = {
        //         companyId:res.data.orglist[0].companyId,
        //         pid:res.data.orglist[0].id
        //     };
        //     https.orgListSearch(datas).then(re=>{
        //         this.companyList = re.data.orglist
        //     })
        //     me.$Loading.finish();
        //     me.$router.push({path:'/productAdd'})
        // })
        // let data = {
        //   companyid:user.companyId,
        //   pid:0,
        //   page:1,
        //   pageSize:10000,
        // }
        // http.all([httpUser.getgoodssortlist(data)]).then(http.spread(function (res1) {
        //   me.yjArr = res1.data;
        //   console.log([me.yjArr])
        //   me.$Loading.finish();
        //   me.isModel = true;
        // }))
        
      },
      shre(){//确定提交商品
        // if (me.name == '' || util.checkSpace(me.name) || util.noBq().test(me.name)) {
        //   me.$message.error('名称不能为空并不能含有空格或者表情');
        //   return false;
        // }
        if (me.name == ''  || util.noBq().test(me.name)) {
          me.$message.error('名称不能为空并不能含有表情');
          return false;
        }
        if (me.num == '' || util.checkSpace(me.num) || util.noBq().test(me.num)) {
          me.$message.error('编码不能为空并不能含有空格或者表情');
          return false;
        }
        // if (me.spec == '' || util.checkSpace(me.spec) || util.noBq().test(me.spec)) {
        //   me.$message.error('规格不能为空并不能含有空格或者表情');
        //   return false;
        // }
        if (me.spec == '' || util.noBq().test(me.spec)) {
          me.$message.error('规格不能为空并不能含有表情');
          return false;
        }
        if (me.jiage == '' || util.checkSpace(me.jiage) || util.noBq().test(me.jiage)) {
          me.$message.error('价格不能为空并不能含有表情');
          return false;
        }
        if (util.checkSpace(me.units) || util.noBq().test(me.units)) {
          me.$message.error('型号不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.guig) || util.noBq().test(me.guig)) {
          me.$message.error('型号不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.erpcode) || util.noBq().test(me.erpcode)) {
          me.$message.error('erp货号编码不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.erpbaseunit) || util.noBq().test(me.erpbaseunit)) {
          me.$message.error('erp基础单位不能含有空格或者表情');
          return false;
        }
        if (util.checkSpace(me.erpunit) || util.noBq().test(me.erpunit)) {
          me.$message.error('erp单位不能含有空格或者表情');
          return false;
        }
        if (me.zuzhi == '' || me.zuzhi == '请选择' || me.erzuzhi == '' || me.erzuzhi == '请选择') {
          me.$message.error('请选择组织架构');
          return false;
        }
        if (me.yiji == '' || me.yiji == '请选择' || me.erji == '' || me.erji == '请选择') {
          me.$message.error('请选择分类');
          return false;
        }
        if (me.imageUrls == '') {
          me.$message.error('请先上传商品图片');
          return false;
        }
        me.$Loading.start();
        let data = {
          name:me.name.trim(),
          code:me.num.trim(),
          specs:me.spec.trim(),
          price:me.jiage.trim(),
          sortid:me.yiji,
          sortid2:me.erji,
          orgid:this.orgid,
          url:me.imageUrls,
          isup:2,
          // commid:me.bpArr.dataList[me.biaop].id,
          companyid:user.companyId,
          model:me.guig,
          unit:me.units,
          erpcode:me.erpcode,
          erpbaseunit:me.erpbaseunit,
          erpunit:me.erpunit,
        }
        // console.log(data);return false;
        https.addorupdatecupgoodsbyorg(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                page:me.page,
                pageSize:me.pageSize,
                companyid:user.companyId,
              }
              https.getgoodslistbyorg(data).then(res => {
                me.data = res.data;
                me.isModel = false;
                me.$Loading.finish();
                me.$message.success('已添加商品');
                setTimeout(function () {
                  me.name = '';
                  me.num = '';
                  me.spec = '';
                  me.jiage = '';
                  me.yiji = '';
                  me.erji = '';
                  me.zuzhi = '';
                  me.erzuzhi = '';
                  me.companyList = [];
                  me.erjiCompanyList = [];
                  me.yjArr = '';
                  me.erArr = [];
                  me.bpArr = [];
                  me.biaop = '';
                  me.imageUrls = '';
                  me.guig = '';
                  me.units = '';
                  me.erpcode = '';
                  me.erpbaseunit = '';
                  me.erpunit = '';
                },500)
                console.log(res);
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
            case "1001":
              me.$Loading.error();
              me.$message.error('重复添加');
              break;
          }
        })
      },
      succGz(e){//文件上传成功后的钩子
        me.imageUrl = e.data;
      },
      succGzs(e){
        me.imageUrls = e.data;
        console.log(e);
      },
      xjsp(){//新建商品
        me.isModel = true;
      },
      seas(){
        me.$Loading.start();
        let data = {
          keyword:me.searchs,
          page:1,
          pageSize:me.pageSize,
          companyid:user.companyId,
        }
        https.getgoodslistbyorg(data).then(res => {
          me.$Loading.finish();
          me.data = res.data;
        })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          page:e,
          pageSize:me.pageSize,
          keyword:me.searchs,
          companyid:user.companyId,
        }
        me.page = e;
        https.getgoodslistbyorg(data).then(res => {
          me.data = res.data;
          me.loading = false;
          console.log(res);
        })
      },
      cancel(){//添加框点击返回
        me.isModel = false;
        setTimeout(function () {
          me.name = '';
          me.num = '';
          me.spec = '';
          me.jiage = '';
          me.yiji = '';
          me.erji = '';
          me.zuzhi = '';
          me.erzuzhi = '';
          me.yjArr = '';
          me.erArr = [];
          me.bpArr = [];
          me.biaop = '';
          me.imageUrls = '';
        },500)
      },
      xgcancel(){
        me.xgModel = false;
        setTimeout(function () {
          me.name = '';
          me.num = '';
          me.spec = '';
          me.jiage = '';
          me.yiji = '';
          me.erji = '';
          me.zuzhi = '';
          me.erzuzhi = '';
          me.yjArr = '';
          me.erArr = [];
          me.bpArr = [];
          me.biaop = '';
          me.xgerji = '';
          me.xgyiji = '';
          me.xgzuzhi = '';
          me.xgerzuzhi = ''
          me.xgjiag = '';
          me.imageUrl = '';
        },500)
      },
    }
  }
</script>

<style scoped>

  @import "djgGoods.css";
</style>